<style lang="less">
.city-cell {
  font-size: 30px;
  padding:0 24px;
  height: 92px;
  line-height: 92px;
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .select-img{
    width:28px;
    height: 20px;
  }
}

.city-cell-selected {
  color: #4169e1;
}

.city-cell-normal {
  color: #333;
}
.location-box {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 104px;
  border-bottom: 1px solid #eeeeee;
  padding-left: 24px;
  font-size: 30px;
  font-family: PingFangSC-Regular;
  .location-img {
    margin-right: 8px;
    width: 22px;
    height: 30px;
  }
  .tips-label {
    font-weight: 400;
    color: rgba(35, 44, 55, 1);
  }
  .location-city {
    font-weight: 600;
    color: rgba(35, 44, 55, 1);
    margin-left: 8px;
  }
  .location-unauthorized {
    font-weight: 600;
    color: rgba(65, 105, 225, 1);
    margin-left: 12px;
  }
  .isopen {
    color: rgba(35, 44, 55, 1);
  }
}
</style>
<template>
  <div style="padding-top;40px;">
    <div class="location-box">
      <img src="../../assets/img/location.png" class="location-img">
      <label class="tips-label">当前定位城市</label>
      <div v-if="isAuth">
        <label class="location-city">{{currentCityName}}</label>
        <label class="isopen" v-if="isOpen">(未开通)</label>
      </div>
      <label class="location-unauthorized" v-else @click="setAuth">未授权</label>
    </div>
    <div
      class="city-cell"
      :class="currentIndex == index ? 'city-cell-selected':'city-cell-normal'"
      v-for="(item,index) in cities"
      :key="item.value"
      @click="cityChoosed(item,index)"
    >
      <label>{{item.name}}</label>
      <img class="select-img" v-if="currentIndex==index" src="../../assets/img/rectangle.png">
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
export default {
  name: "city",
  data() {
    return {
      cities: [],
      isOpen: true,
      isAuth: true,
      currentCityName: "",
      currentIndex: -1
    };
  },
  created() {
    let options = this.$route.query;
    this.currentCityName = options.currentCityName;
    this.currentIndex = options.selectCityIndex;
    const toast = Toast.loading({
      duration: 0, // 持续展示 toast
      forbidClick: true, // 禁用背景点击
      loadingType: "spinner"
    });
    let res = this.$axios
      .post("api/xz/city/list/")
      .then(res => {
        if (res.success) {
          this.cities = res.result;
          for (let i = 0; i < this.cities.length; i++) {
            if (this.cities[i].name == this.currentCityName) {
              this.isOpen = false;
            }
          }
        }
        Toast.clear();
      })
      .catch(err => {
        console.log(err);
      });
    // this.getPosition();
  },
  mounted() {},
  methods: {
    //去授权
    setAuth() {
      let self = this;
      wx.showModal({
        title: "提示",
        content: "点击确认去开启授权信息",
        confirmColor: "#2346fa",
        success: result => {
          if (result.confirm) {
            // 授权获取用户位置信息
            wx.openSetting({
              complete(res) {
                if (res.authSetting["scope.userLocation"]) {
                  self.getPosition();
                  self.isAuth = true;
                } else {
                  self.isAuth = false;
                }
              }
            });
          } else {
            self.isAuth = false;
          }
        }
      });
    },
    //选择城市
    cityChoosed: function(item,index) {
      this.currentIndex = index;
      let info ={
        currentIndex:index,
        item:item
      }
      localStorage.setItem("city", JSON.stringify(info));
      localStorage.removeItem("screen");
      this.isMiniProgram(res => {
        if (res) {
          wx.miniProgram.reLaunch({url: '/pages/home/index'});
        } else {
          this.$router.push({
            path: "/",
            replace:true
          });      
        }
      });
    },
    getPosition() {
      const self = this;
      let pages = getCurrentPages();
      let homepage = pages.find(p => p.route == "pages/home/index");
      wx.getSetting({
        success: res => {},
        fail: res => {},
        complete: res => {
          if (res.authSetting["scope.userLocation"]) {
            if (homepage) {
              homepage.getLocation(1, function(e) {
                let str = e.result.ad_info.city;
                self.currentCityName = str.substring(0, str.length - 1);
              });
            }
            self.isAuth = true;
          } else {
            self.isAuth = false;
          }
        }
      });
    }
  },
  destroyed() {}
};
</script>




// WEBPACK FOOTER //
// src/pages/select_city/index.vue